const PrivacyPolicy = () => {
  return (
    <div style={{ margin: "20px" }}>
      <h1>Política de Privacidad</h1>
      <p>Última actualización: 10 de Mayo 2024</p>
      <p>
        SupplyTechStore opera el sitio web y la aplicación móvil
        SupplyTechStore.
      </p>
      <p>
        Esta página le informa de nuestras políticas respecto a la recopilación,
        uso y divulgación de datos personales cuando utiliza nuestro Servicio y
        las elecciones que ha asociado con esos datos.
      </p>

      <h2>Información que recopilamos</h2>
      <h3>Información proporcionada por el usuario</h3>
      <p>
        Recopilamos diferentes tipos de información para proporcionar y mejorar
        nuestro Servicio a usted. Los tipos de datos personales que podemos
        recopilar incluyen, pero no se limitan a:
      </p>
      <ul>
        <li>
          Datos de Identificación personal (nombre y dirección de correo
          electrónico.)
        </li>
        <li>Datos de transacciones (detalles de compras y pagos)</li>
        <li>Cookies y Datos de Uso</li>
      </ul>

      <h2>Uso de los datos</h2>
      <p>Utilizamos los datos recopilados por varias razones:</p>
      <ul>
        <li>Para proporcionar y mantener nuestro Servicio</li>
        <li>Para notificarle sobre cambios en nuestro Servicio</li>
        <li>
          Para permitirle participar en funciones interactivas de nuestro
          Servicio cuando elija hacerlo
        </li>
        <li>Para proporcionar atención al cliente</li>
        <li>
          Para recopilar análisis o información valiosa para que podamos mejorar
          nuestro Servicio
        </li>
        <li>Para monitorear el uso del Servicio</li>
        <li>Para detectar, prevenir y abordar problemas técnicos</li>
      </ul>

      <h2>Transferencia de datos</h2>
      <p>
        Su información, incluyendo Datos Personales, puede ser transferida a — y
        mantenida en — computadoras localizadas fuera de su estado, provincia,
        país u otra jurisdicción gubernamental donde las leyes de protección de
        datos pueden diferir de las de su jurisdicción.
      </p>
      <p>
        Si usted se encuentra fuera de [tu país] y decide proporcionarnos
        información, tenga en cuenta que transferimos los datos, incluyendo
        Datos Personales, a [tu país] y los procesamos allí.
      </p>

      <h2>Divulgación de datos</h2>
      <p>
        Bajo ciertas circunstancias, podemos requerir revelar sus Datos
        Personales si así lo requiere la ley o en respuesta a solicitudes
        válidas por parte de las autoridades públicas (por ejemplo, un tribunal
        o una agencia gubernamental).
      </p>

      <h2>Seguridad de los datos</h2>
      <p>
        La seguridad de sus datos es importante para nosotros, pero recuerde que
        ningún método de transmisión por Internet o método de almacenamiento
        electrónico es 100% seguro. Aunque nos esforzamos por usar medios
        comercialmente aceptables para proteger sus Datos Personales, no podemos
        garantizar su seguridad absoluta.
      </p>

      <h2>Cambios en esta política de privacidad</h2>
      <p>
        Podemos actualizar nuestra Política de Privacidad periódicamente. Le
        notificaremos cualquier cambio publicando la nueva Política de
        Privacidad en esta página.
      </p>
      <p>
        Se le aconseja revisar esta Política de Privacidad periódicamente para
        cualquier cambio. Los cambios a esta Política de Privacidad son
        efectivos cuando se publican en esta página.
      </p>

      <h2>Contacto</h2>
      <p>
        Si tiene alguna pregunta sobre esta Política de Privacidad, por favor
        contáctenos:
      </p>
      <ul>
        <li>Por email: supplytech.soldaduras@gmail.com</li>
        <li>Por teléfono: +58 412-2763933</li>
        <li>
          Por dirección: Av. Bolivar Oeste #150 C/C Av. Ayacucho, Edificio Don
          Antonio, Piso B, Local 2, Sector casco central de Maracay, Edo.
          Aragua, Zona postal 2101
        </li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
